import { formatDate } from "../utils";
import {
  calculaSubtotalParaChave,
  calculoDesconto,
  totalItensLista,
  totalPagamentos,
  totalVenda,
} from "./pdv.js";
import {
  NfSaidaPagamento,
  NfSaidaEnderecoCliente,
  nfSaidaTotalTributos,
  OperacaoFiscal,
  NfSaidaItem,
} from "./index";
import { estadosLista } from "../resources";
import { format } from "date-fns";
import { de } from "date-fns/locale";

export class NfSaida {
  status = null;
  pedidoIds = null;
  orcamentoIds = null;
  serieDocumento = null;
  dataEmissao = null;
  operacaoFiscalId = null;
  grupoTributarios = null;
  modeloDocumento = null;
  notasCredito = null;
  operacaoFiscal = null;
  chaveAcesso = null;
  urlChave = null;
  quantidadeParcelas = null;
  chaveAcessoReferencia = null;
  clienteId = null;
  clienteEmail = null;
  clienteNome = null;
  clienteCnpjCpf = null;
  vendedorId = null;
  prestadorServicoId = null;
  modalidadeFrete = null;
  freteCompoeNota = null;
  desconto = null;
  descontoPorcentagem = null;
  acrescimo = null;
  despesas = null;
  totalVenda = 0;
  totalMercadoria = 0;
  totalPagamentos = 0;
  informacoesAdicionais = null;
  informacoesFisco = null;
  nfSaidaEnderecoCliente = null;
  documentoDevolucaoCliente = null;
  documentoDevolucaoFornecedor = null;
  frete = null;
  transportadoraId = null;
  transportadoraNome = null;
  transportadoraCnpjCpf = null;
  transportadoraIe = null;
  transportadoraEnderecoRua = null;
  transportadoraEnderecoMunicipio = null;
  transportadoraEnderecoUf = null;
  qtdVolumes = null;
  nfSaidaItens = null;
  nfSaidaPagamentos = null;
  devolucoesClienteIds = null;
  devolucoesFornecedorIds = null;
  nfSaidaImportadaId = null;
  orcamentoImport = null;
  pedidoImport = null;
  importacaoDocumento = null;
  vendedorObrigatorio = null;
  enderecoEntregaId = null;
  vendedorBancoCaixaId = null;
  meioPagamentoId = null;
  condicaoPagamentoId = null;
  dataSaida = null;
  emitidoPdv = true;
  createdAt = null;
  updatedAt = null;
  presencaConsumidor = null;

  constructor(nfSaida) {
    this.status = nfSaida.status;
    this.orcamentoImport = nfSaida.orcamentoImport;
    this.pedidoImport = nfSaida.pedidoImport;
    this.importacaoDocumento = nfSaida.importacaoDocumento;
    this.pedidoIds = nfSaida.pedidoIds;
    this.orcamentoIds = nfSaida.orcamentoIds;
    this.serieDocumento = nfSaida.serieDocumento;
    this.numeroDocumento = nfSaida.id ? nfSaida.numeroDocumento : undefined;
    this.dataEmissao = nfSaida.dataEmissao || formatDate.toSend(new Date());
    this.operacaoFiscalId = nfSaida.operacaoFiscalId;
    this.grupoTributarios = nfSaida.grupoTributarios;
    this.modeloDocumento = nfSaida.modeloDocumento;
    this.notasCredito = nfSaida.notasCredito;
    this.operacaoFiscal = nfSaida.operacaoFiscal;
    this.chaveAcesso = nfSaida.chaveAcesso;
    this.urlChave = nfSaida.urlChave;
    this.quantidadeParcelas = nfSaida.quantidadeParcelas;
    this.chaveAcessoReferencia = nfSaida.chaveAcessoReferencia;
    this.clienteId = nfSaida.clienteId;
    this.clienteEmail = nfSaida.clienteEmail;
    this.clienteNome = nfSaida.clienteNome;
    this.clienteCnpjCpf = nfSaida.clienteCnpjCpf;
    this.vendedorId = nfSaida.vendedorId;
    this.vendedorBancoCaixaId = nfSaida.vendedorBancoCaixaId;
    this.prestadorServicoId = nfSaida.prestadorServicoId;
    this.modalidadeFrete = nfSaida.modalidadeFrete || "mfSemFrete";
    this.transportadoraId = nfSaida.transportadoraId;
    this.transportadoraNome = nfSaida.transportadoraNome;
    this.transportadoraCnpjCpf = nfSaida.transportadoraCnpjCpf;
    this.transportadoraIe = nfSaida.transportadoraIe;
    this.transportadoraEnderecoRua = nfSaida.transportadoraEnderecoRua;
    this.transportadoraEnderecoMunicipio =
      nfSaida.transportadoraEnderecoMunicipio;
    this.transportadoraEnderecoUf = nfSaida.transportadoraEnderecoUf;
    this.qtdVolumes = nfSaida.qtdVolumes;
    this.freteCompoeNota = nfSaida.freteCompoeNota || false;
    this.desconto = nfSaida.desconto;
    this.descontoPorcentagem = nfSaida.descontoPorcentagem;
    this.acrescimo = nfSaida.acrescimo;
    this.despesas = nfSaida.despesas;
    this.totalMercadoria = nfSaida.totalMercadoria;
    this.totalPagamentos =
      nfSaida.totalPagamentos || totalPagamentos(this.nfSaidaPagamentos);
    this.totalVenda = nfSaida.totalVenda;
    this.informacoesAdicionais = nfSaida.informacoesAdicionais;
    this.informacoesFisco = nfSaida.informacoesFisco;
    this.nfSaidaEnderecoCliente = nfSaida.nfSaidaEnderecoCliente
      ? new NfSaidaEnderecoCliente(nfSaida.nfSaidaEnderecoCliente)
      : null;
    this.documentoDevolucaoCliente = nfSaida.documentoDevolucaoCliente;
    this.documentoDevolucaoFornecedor = nfSaida.documentoDevolucaoFornecedor;
    this.frete = nfSaida.frete;
    this.nfSaidaItens = nfSaida.nfSaidaItens;
    this.nfSaidaPagamentos = nfSaida.nfSaidaPagamentos?.length
      ? nfSaida.nfSaidaPagamentos.map(
          (pagamento) => new NfSaidaPagamento(pagamento),
        )
      : [];
    this.devolucoesClienteIds = nfSaida?.devolucoesClienteIds || null;
    this.devolucoesFornecedorIds = nfSaida?.devolucoesFornecedorIds || null;
    this.nfSaidaImportadaId = nfSaida.nfSaidaImportadaId;
    this.vendedorObrigatorio = nfSaida.vendedorObrigatorio;
    this.enderecoEntregaId = nfSaida.enderecoEntregaId;
    this.meioPagamentoId = nfSaida.meioPagamentoId;
    this.condicaoPagamentoId = nfSaida.condicaoPagamentoId;
    this.dataEmissao = nfSaida?.dataEmissao || formatDate.toSend(new Date());
    this.modalidadeFrete = nfSaida?.modalidadeFrete || "mfSemFrete";
    this.freteCompoeNota = nfSaida?.freteCompoeNota || false;
    this.presencaConsumidor = nfSaida?.presencaConsumidor || null;
  }

  geraCodigoNumerico(documentoDataEmissao) {
    const date = isNaN(documentoDataEmissao?.getTime?.())
      ? new Date()
      : documentoDataEmissao;
    const str = (date.getTime() + 11644473600000).toString() + "0000";
    return str.substring(4, 12);
  }

  gerarChaveAcesso(dadosEmpresa) {
    const dataEmissaoDate = this.dataEmissao
      ? new Date(this.dataEmissao)
      : new Date();
    if (!this.dataEmissao) {
      this.dataEmissao = dataEmissaoDate.toISOString();
    }
    const dataFormatada = format(
      isNaN(dataEmissaoDate.getTime()) ? new Date() : dataEmissaoDate,
      "yyMM",
    );
    const numeroFormatado = (this.numeroDocumento || 0)
      .toString()
      .padStart(9, "0");
    const serieFormatada = (this.serieDocumento || 0)
      .toString()
      .padStart(3, "0");
    const modeloFormatado = (this.modeloDocumento || "65")
      .toString()
      .padStart(2, "0");
    const uf =
      estadosLista
        .find((e) => e.sigla === dadosEmpresa?.enderecoUF)
        ?.cod?.toString()
        .padStart(2, "0") || "";
    const estado = dadosEmpresa?.enderecoUF?.toLowerCase() || "";
    const rawDoc = (dadosEmpresa?.cnpjCpf || "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase();
    const cnpj = rawDoc.padStart(14, "0");
    const codigoNumerico = (
      this.codigoNumerico ||
      this.cNF ||
      this.geraCodigoNumerico(dataEmissaoDate)
    )
      .toString()
      .padStart(8, "0");
    this.codigoNumerico = codigoNumerico;
    this.cNF = codigoNumerico;
    const initKey = `${uf}${dataFormatada}${cnpj}${modeloFormatado}${serieFormatada}${numeroFormatado}1${codigoNumerico}`;
    const calculoDV = this.calculoDV11(initKey);
    this.chaveAcesso = initKey + calculoDV;
    this.urlChave = this.getUrlChaveEstado(estado, this.chaveAcesso);
  }

  getUrlChaveEstado(estado, chave) {
    const urls = {
      ac: "http://www.sefaznet.ac.gov.br/nfce/qrcode?p=",
      al: "http://nfce.sefaz.al.gov.br/QRCode/consultarNFCe.jsp?p=",
      ap: "https://www.sefaz.ap.gov.br/nfce/nfcep.php?p=",
      am: "http://sistemas.sefaz.am.gov.br/nfceweb/consultarNFCe.jsp?chNFe=",
      ba: "http://nfe.sefaz.ba.gov.br/servicos/nfce/qrcode.aspx?p=",
      ce: "http://nfce.sefaz.ce.gov.br/pages/ShowNFCe.html?p=",
      df: "http://www.fazenda.df.gov.br/nfce/qrcode?p=",
      es: "http://app.sefaz.es.gov.br/ConsultaNFCe?p=",
      go: "https://nfeweb.sefaz.go.gov.br/nfeweb/sites/nfce/danfeNFCe?p=",
      ma: "http://nfce.sefaz.ma.gov.br/portal/consultarNFCe.jsp?p=",
      mt: "http://www.sefaz.mt.gov.br/nfce/consultanfce?p=",
      ms: "http://www.dfe.ms.gov.br/nfce/qrcode?p=",
      mg: "https://portalsped.fazenda.mg.gov.br/portalnfce/sistema/qrcode.xhtml?p=",
      pa: "https://appnfc.sefa.pa.gov.br/portal/view/consultas/nfce/nfceForm.seam?p=",
      pb: "http://www.sefaz.pb.gov.br/nfce?p=",
      pr: "http://www.fazenda.pr.gov.br/nfce/qrcode?p=",
      pe: "http://nfce.sefaz.pe.gov.br/nfce/consulta?p=",
      pi: "http://www.sefaz.pi.gov.br/nfce/qrcode?p=",
      rj: "https://consultadfe.fazenda.rj.gov.br/consultaNFCe/QRCode?p=",
      rn: "https://nfce.sefaz.rn.gov.br/consultarNFCe.aspx?p=",
      rs: "https://www.sefaz.rs.gov.br/NFCE/NFCE-COM.aspx?p=",
      ro: "http://www.nfce.sefin.ro.gov.br/consultanfce/consulta.jsp?p=",
      rr: "https://www.sefaz.rr.gov.br/nfce/servlet/qrcode?p=",
      sc: "https://sat.sef.sc.gov.br/nfce/consulta?p=",
      sp: "https://www.nfce.fazenda.sp.gov.br/qrcode?p=",
      se: "http://www.nfce.se.gov.br/nfce/qrcode?p=",
      to: "http://www.sefaz.to.gov.br/nfce/qrcode?p=",
    };
    const baseUrl = urls[estado] || urls.ba;
    return `${baseUrl}${chave}|3|1`;
  }

  calculoDV11(strNumero) {
    if (!strNumero) {
      return "";
    }
    let total = 0;
    let weight = 2;
    for (let i = strNumero.length - 1; i >= 0; i--) {
      const char = strNumero[i];
      let digit = parseInt(char, 10);
      if (isNaN(digit)) {
        digit = char.charCodeAt(0) - 48;
      }
      total += digit * weight;
      weight = weight < 9 ? weight + 1 : 2;
    }
    const remainder = total % 11;
    return remainder === 0 || remainder === 1
      ? "0"
      : (11 - remainder).toString();
  }

  // geraCodigoNumerico(dataEmissao) {
  //   const date =
  //     dataEmissao && !isNaN(dataEmissao.getTime()) ? dataEmissao : new Date();
  //   const utcMilliseconds = date.getTime().toString();
  //   return utcMilliseconds.slice(-8).padStart(8, "0");
  // }

  arendondarQuantidadesItens() {
    this.nfSaidaItens = this.nfSaidaItens.map((nfSaidaItem) => ({
      ...nfSaidaItem,
      quantidade: Math.round(nfSaidaItem.quantidade * 1000) / 1000,
    }));
  }

  setChangeItens(id, itens, nfSaida = this) {
    this.desconto = calculaSubtotalParaChave(itens, "", "desconto");
    this.acrescimo = calculaSubtotalParaChave(itens, "", "acrescimo");
    this.despesas = calculaSubtotalParaChave(itens, "", "despesas");
    this.nfSaidaItens = itens?.length
      ? itens.map(
          (item, index) => new NfSaidaItem(item, index, this.operacaoFiscal),
        )
      : [];
    this.baseIcmsTotal = nfSaidaTotalTributos.totalBaseIcms(id, itens, nfSaida);
    this.valorIcmsTotal = nfSaidaTotalTributos.totalValorIcms(
      id,
      itens,
      nfSaida,
    );
    this.baseIcmsSt = nfSaidaTotalTributos.totalBaseIcmsSt(id, itens, nfSaida);
    this.valorIcmsSt = nfSaidaTotalTributos.totalValorIcmsSt(
      id,
      itens,
      nfSaida,
    );
    this.valorIpiTotal = nfSaidaTotalTributos.totalValorIpi(id, itens, nfSaida);
    this.totalMercadoria = totalItensLista(itens);
    this.totalVenda = totalVenda(nfSaida, itens);
    this.descontoPorcentagem = calculoDesconto(itens, nfSaida, false);
    this.grupoTributarios = [
      ...new Set(this.nfSaidaItens.map((item) => item.grupoTributacaoId)),
    ];
  }

  setChangePagamentos(pagamentos) {
    this.nfSaidaPagamentos = pagamentos?.length
      ? pagamentos.map((pagamento) => new NfSaidaPagamento(pagamento))
      : [];
    this.totalPagamentos = totalPagamentos(pagamentos);
  }

  setIdentificarCliente(value) {
    this.clienteId = value?.id;
    this.clienteEmail = value?.email;
    this.clienteCnpjCpf = value?.cnpjCpf;
    this.clienteNome = value?.nomeRazaoSocial;
  }

  setVendedorObrigatorioPermissao(permissao) {
    this.vendedorObrigatorio = permissao;
  }

  setEnderecoCliente(enderecoAlterado, enderecoCliente) {
    if (this.clienteId) {
      const endereco = enderecoAlterado || enderecoCliente;
      if (endereco) {
        this.nfSaidaEnderecoCliente = {
          ...endereco,
          pessoaId: this.clienteId,
        };
        return;
      }
    }
    this.nfSaidaEnderecoCliente = {};
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setHandleChangeDate(name, date) {
    this[name] = date !== "Invalid Date" ? formatDate.toSend(date) : undefined;
  }

  setHandleChangeAutoComplete(name, value) {
    this[name] = value ? value.id : null;
    if (name === "clienteId") {
      this.setIdentificarCliente(value);
    }
    if (name === "transportadoraId") {
      this.transportadoraNome = value?.nomeRazaoSocial;
      this.transportadoraCnpjCpf = value?.cnpjCpf;
      this.transportadoraIe = value?.inscricaoEstadual;
      this.transportadoraEnderecoRua = value?.enderecos[0]?.logradouro;
      this.transportadoraEnderecoMunicipio = value?.enderecos[0]?.cidade?.nome;
      this.transportadoraEnderecoUf = value?.enderecos[0]?.cidade?.estado.sigla;
    }
  }

  setOperacaoFiscal(operacaoFiscal) {
    this.operacaoFiscal = new OperacaoFiscal(operacaoFiscal);
    this.operacaoFiscalId = operacaoFiscal.id;
    this.serieDocumento = operacaoFiscal?.serieDocumento;
    this.modeloDocumento = operacaoFiscal?.modeloDocumento;
    this.presencaConsumidor = operacaoFiscal?.presencaConsumidor;
  }

  setColaboradorVendedorUsuario(
    vendedorId,
    vendedorBancoCaixaId,
    permissaoUtilizarCaixa,
  ) {
    this.vendedorId = vendedorId;
    if (permissaoUtilizarCaixa) {
      this.vendedorBancoCaixaId = vendedorBancoCaixaId;
    }
  }

  setNotasCredito(notasCredito) {
    this.notasCredito = notasCredito;
  }

  setVendedorBancoCaixaId(bancoCaixaId) {
    this.vendedorBancoCaixaId = bancoCaixaId;
  }

  setDataSaida(dataSaida) {
    this.dataSaida = dataSaida;
  }

  setTimeStamp() {
    const dataAtual = formatDate.toSend(new Date());
    this.createdAt = dataAtual;
    this.updatedAt = dataAtual;
  }

  setDadosImportacao(importacao) {
    this.pedidoImport = true;
    this.informacoesAdicionais = importacao.informacoesAdicionais;
    this.pedidoIds = importacao.pedidoIds;
    this.clienteId = importacao?.clienteId;
    this.vendedorId = importacao?.vendedorId;
    this.desconto = importacao.desconto ?? 0;
    this.acrescimo = importacao.acrescimo ?? 0;
    this.despesas = importacao.despesas ?? 0;
    this.prestadorServicoId = importacao.prestadorServicoId;
  }
}
